// extracted by css-extract-rspack-plugin
export default {"grid":"VideoGallery-module__grid--uGDMT"};